import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import HabitUserDetail from '../../../HabitsHub/HabitUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyHabitsUserDetail } from './companyHabitsApi';

/**
 * Company Habits → one employee's/member's habit profile. Reuses the shared
 * detail page with the company-scoped fetcher (the backend 404s any user who
 * doesn't belong to this company).
 */
const CHabitsUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Habit Profile | Shoorah</title>
      </Helmet>
      <HabitUserDetail
        fetcher={fetchCompanyHabitsUserDetail}
        backPath={`/${slug}/habits/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CHabitsUserDetail;
